export const getQueryVariable = (variable: string) => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");

  for (let i = 0; i < vars.length; i++) {
    const pairIndex = vars[i].indexOf("=");
    const pairKey = vars[i].substring(0, pairIndex);
    const pairValue = vars[i].substring(pairIndex + 1);

    if (pairKey == variable) {
      return decodeURIComponent(decodeURIComponent(pairValue));
    }
  }

  return false;
};

export const browser = (function () {
  const ua = navigator.userAgent;
  const version = {
    isIos: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios 终端
    isWindows: ua.indexOf("Windows") > -1, // windows终端
    isMobile: !!ua.match(/AppleWebKit.*Mobile.*/), // 是否移动终端
    isIpad: !!navigator.userAgent.match(/(iPad)/) || (ua.indexOf("Macintosh") > -1 && navigator.maxTouchPoints > 1),
    isWebApp: ua.indexOf("Safari") === -1, // 是否为Webapp，没有头部和底部
    isTrident: ua.indexOf("Trident") > -1, // IE内核
    isPresto: ua.indexOf("Presto") > -1, // opera 内核
    isWebKit: ua.indexOf("AppleWebKit") > -1, // 苹果谷歌内核
    isGecko: ua.indexOf("Gecko") > -1 && ua.indexOf("KHTML") === -1, // 火狐内核
    isWechat: !!ua.match(/micromessenger/gi),
    isWeiBo: !!ua.match(/weibo/gi),
    isQQ: !!ua.match(/qq/gi)
  };
  const language = navigator?.language?.toLowerCase() || "en";
  const screen = { clientWidth: document.documentElement.clientWidth, height: document.documentElement.clientHeight };
  // console.error('main docEl.clientWidth ', document.documentElement.clientWidth)
  // console.error('main docEl.clientHeight ', )
  return {
    version,
    language,
    screen
  };
})();

export const getVid = (function () {
  let localId = "";
  return function () {
    if (localId) return localId;
    let vid = window.localStorage.getItem("EVENT_VID");
    if (vid) {
      localId = vid;
      return vid;
    }
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
      d += performance.now(); //use high-precision timer if available
    }
    vid = "xxxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (d + Math.random() * 16) % 16 | 0; // d是随机种子
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    window.localStorage.setItem("EVENT_VID", vid);
    return vid;
  };
})();

export const getSid = (function () {
  function formatDateTime() {
    const date = new Date();
    const y = String(date.getFullYear());
    let m = String(date.getMonth() + 1);
    m = +m < 10 ? "0" + m : m;
    let d = String(date.getDate());
    d = +d < 10 ? "0" + d : d;
    const h = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return y + m + d + h + minute + second;
  }
  let localData: any = {};
  return function () {
    if (localData.sid && localData.time > Date.now()) {
      return localData.sid;
    }
    const local = window.sessionStorage.getItem("EVENT_SID");
    if (local) {
      const data = JSON.parse(local);
      if (data.time > Date.now()) {
        localData = data;
        return localData.sid;
      }
    }
    localData.sid = formatDateTime() + Math.random().toString(36).substr(2);
    localData.time = Date.now() + 30 * 60 * 1000;
    window.sessionStorage.setItem("EVENT_SID", JSON.stringify(localData));
    return localData.sid;
  };
})();

export function debounce<T extends (...args: any[]) => any>(func: T, wait: number): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return function (...args: Parameters<T>): void {
    const later = () => {
      timeoutId = null;
      func(...args);
    };

    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(later, wait);
  };
}

function padLeftZero(str: string | any[]) {
  return ("00" + str).substr(str.length);
}

export const formatDate = (timestemp: number, fmt?: string) => {
  if (!timestemp) return "";

  fmt = fmt || "YYYY-MM-DD hh:mm:ss";

  if (timestemp.toString().length === 10) {
    timestemp *= 1e3;
  }

  const date = new Date(timestemp);
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  const o = {
    "M+": date.getMonth() + 1,
    "D+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  } as any;
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + "";
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
};
